import type { Progress } from './getScoreRangeValue'

export const MAX_SCORE = 100

export function getScoreTextClass(range: Progress): string {
  if (range === 3) return 'text-success'
  if (range === 2) return 'text-warning'
  if (range === 1) return 'text-destructive'
  return 'text-border'
}

export function getScoreGradientBgClass(range: Progress): string {
  if (range === 3) return 'bg-[linear-gradient(180deg,rgb(var(--success-300))_0%,rgb(var(--success))_100%)]'
  if (range === 2) return 'bg-[linear-gradient(180deg,rgb(var(--warning-300))_0%,rgb(var(--warning))_100%)]'
  if (range === 1) return 'bg-[linear-gradient(180deg,rgb(var(--error-300))_0%,rgb(var(--destructive))_100%)]'
  return 'bg-[linear-gradient(180deg,rgb(var(--error-300))_0%,rgb(var(--destructive))_100%)]'
}

export function getScoreSvgColors(range: Progress): { inner: string; outer: string } {
  if (range === 3) return { inner: 'rgb(var(--success))', outer: 'rgb(var(--success-300))' }
  if (range === 2) return { inner: 'rgb(var(--warning))', outer: 'rgb(var(--warning-300))' }
  return { inner: 'rgb(var(--destructive))', outer: 'rgb(var(--error-300))' }
}

export function getSeverityTextClass(severity: 'critical' | 'warning' | 'info'): string {
  if (severity === 'critical') return 'text-destructive'
  if (severity === 'warning') return 'text-warning'
  return 'text-accent'
}

export function getSeverityClasses(severity: 'critical' | 'warning' | 'info'): string {
  if (severity === 'critical') return 'border-destructive bg-destructive/10 text-destructive'
  if (severity === 'warning') return 'border-warning bg-warning/10 text-warning'
  return 'border-accent bg-accent/10 text-accent'
}
